import * as Common from '@/agiles/common';
import { WorkflowState } from './workflowState';
import { WorkflowAction } from './workflowAction';


export class Workflow extends Common.ObjectBase {
  constructor() {
    super('Workflow');
    this.binders.userStates = new Common.ModelBinder(WorkflowState);
    this.binders.controller = new Common.ModelBinder(WorkflowController);
  }
  public id: number;
  public name: string;
  public code1: string;
  public code2: string;
  public displayOrder:number = 0;

  public copy():any {
    const temp = super.copy() as Workflow;
    temp.id = 0;
    return temp;
  }

  // public get fullStates() :string[]{
  //   const result = new Array();
  //   this.entry.systemStates.forEach(state => result.push(state.name));
  //   this.userStates.forEach(state => result.push(state.name));
  //   return result;
  // }
  public getState(stateId: number) {
    let result = this.controller.systemStates.find(obj => obj.workflowStateId == stateId);
    if (result != null) return result;
    result = this.userStates.find(obj => obj.workflowStateId == stateId);
    if (result != null) return result;
    else return null;
  }
  public getName(stateId: number) {
    let result = this.controller.systemStates.find(obj => obj.workflowStateId == stateId);
    if (result != null) return result.name;
    result = this.userStates.find(obj => obj.workflowStateId == stateId);
    if (result != null) return result.name;
    else return '';
  }

  public getSectionName(sectionId:number){
    return this.controller.sections.find(sec =>sec.value == sectionId).text;
  }

  public getSectionList() {
    return this.controller.sections.slice(1);
  }
    
  /**ワークフロー遷移先・遷移元 */
  public getList(): Common.BindItem[] {
    const result = new Array();
    //自動判定ステータス以外を返す。
    this.controller.systemStates.filter(state=> (state.type & Common.StateTypes.AutoStatus) != Common.StateTypes.AutoStatus).forEach(state => result.push(new Common.BindItem(state.workflowStateId, state.name)));
    this.userStates.forEach(state => result.push(new Common.BindItem(state.workflowStateId, state.name)));
    return result;
  }
  /**ワークフロー割当先(開始・終了を除く) */
  public getList2(): Common.BindItem[] {
    const result = new Array();
    this.controller.systemStates.forEach(state =>{
      if ((state.type & Common.StateTypes.EntryStatus)  != Common.StateTypes.EntryStatus && (state.type & Common.StateTypes.ExitStatus)  != Common.StateTypes.ExitStatus)
      result.push(new Common.BindItem(state.workflowStateId, state.name))});
    this.userStates.forEach(state => result.push(new Common.BindItem(state.workflowStateId, state.name)));
    return result;
  }

  public getCodeName(code:string):string{
    const item = this.controller.systemFlags.find(o=>o.value == code);
    return item ? item.text: '';
  }

  public getHolderName(code:string): string{
    const item = this.controller.systemHolders.find(o=>o.value == code);
    return item ? item.text: null;    
  }

  public userStates: WorkflowState[] = new Array();
  public controller: WorkflowController; //システムStatesを提供
}

export class WorkflowQuery extends Common.LoadQuery {
  constructor() {
    super('WorkflowQuery', Workflow);
    this.sort = 'workflow';
  }
  public name:string;  
  public controller: WorkflowController;   
  public id:number = null;
}

export class WorkflowController extends Common.ObjectBase {
  constructor() {
    super('WorkflowController');
    this.binders.systemStates = new Common.ModelBinder(WorkflowState);
    this.binders.systemActions = new Common.ModelBinder(WorkflowAction);
    this.binders.systemHolders = new Common.ModelBinder(Common.BindItem2);
  }
  
  public code: string;
  public name: string;
  public systemStates: WorkflowState[] = new Array();
  public systemActions: WorkflowAction[] = new Array();
  public systemHolders: Common.BindItem[] = new Array();
  public systemFlags: Common.BindItem[] = new Array();
  public sections: Common.BindItem[] = new Array();


  public getList(): Common.BindItem[] {
    return this.systemHolders;
  }
}

export class WorkflowControllerQuery extends Common.LoadQuery {
  constructor() {
    super('WorkflowControllerQuery', WorkflowController);
  }
}
